import { Query } from 'redux-little-router';

import { FreelancerCustomersTabs } from '../../typings/freelancers';

const freelancerCustomersTabQueryParams = {
    [FreelancerCustomersTabs.ACTIVE]: 'active',
    [FreelancerCustomersTabs.CANCELED]: 'canceled',
    [FreelancerCustomersTabs.REQUESTED]: 'requested'
};

const DEFAULT_CUSTOMERS_TAB = FreelancerCustomersTabs.ACTIVE;

export function mapFreelancerCustomersTabToQueryParam(tab: FreelancerCustomersTabs): string {
    return freelancerCustomersTabQueryParams[tab];
}

export function mapFreelancerCustomersQueryParamToTab(queryParams?: Query): FreelancerCustomersTabs {
    const tabQueryParam = queryParams && queryParams.tab;

    if (!tabQueryParam) {
        return DEFAULT_CUSTOMERS_TAB;
    }

    const tabKey = Object.keys(freelancerCustomersTabQueryParams).find(
        key => freelancerCustomersTabQueryParams[key] === tabQueryParam
    );

    return (Number(tabKey) || DEFAULT_CUSTOMERS_TAB) as FreelancerCustomersTabs;
}
